import { TrackingEventDetails } from "./TrackingEventDetails";

export default TrackingEventDetails;
